import { render, staticRenderFns } from "./onboarding-edit.vue?vue&type=template&id=05253c92&scoped=true"
import script from "./onboarding-edit.vue?vue&type=script&lang=js"
export * from "./onboarding-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05253c92",
  null
  
)

export default component.exports